import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TESTIDS } from "@/constants/testIds";
import { EFFECTIVE_STATUS, EFFECTIVE_STATUS_CLS } from "@/constants/roles";

function fmt(dt) {
  if (!dt) return "—";
  return new Date(dt).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
}

export default function HistoryPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/attendance/history");
        setRows(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div data-testid={TESTIDS.historyPage} className="space-y-6">
      <div>
        <div className="label-tiny">Riwayat</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Riwayat Absensi Saya</h1>
      </div>
      <div className="border border-black/10 bg-white overflow-x-auto">
        <table data-testid={TESTIDS.historyTable} className="w-full text-sm min-w-[800px]">
          <thead className="bg-black text-white text-left">
            <tr><Th>Tanggal</Th><Th>Lokasi</Th><Th>Check-in</Th><Th>Check-out</Th><Th>Status Absensi</Th><Th>Jarak</Th></tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} className="p-8 text-center text-gray-500">Memuat...</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-gray-500">Belum ada data.</td></tr>}
            {rows.map((r) => {
              const es = r.effective_status || (r.status === "late" ? "terlambat" : "ontime");
              const cls = EFFECTIVE_STATUS_CLS[es] || "bg-gray-200";
              const label = EFFECTIVE_STATUS[es] || "—";
              return (
                <tr key={r.attendance_id} className="border-t border-black/10 hover:bg-gray-50">
                  <Td className="font-mono">{r.date}</Td>
                  <Td className="text-xs">{r.is_wfa ? <span className="text-klein font-semibold">WFA</span> : r.office_name}</Td>
                  <Td className="font-mono">{fmt(r.check_in_time)}</Td>
                  <Td className="font-mono">{fmt(r.check_out_time)}</Td>
                  <Td><span className={`px-2 py-1 text-xs font-bold uppercase tracking-widest ${cls}`}>{label}</span></Td>
                  <Td className="font-mono">{r.check_in_distance != null ? `${r.check_in_distance} m` : "—"}</Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
const Th = ({ children }) => <th className="px-4 py-3 text-xs uppercase tracking-widest font-bold">{children}</th>;
const Td = ({ children, className = "" }) => <td className={`px-4 py-3 ${className}`}>{children}</td>;
